import { CommonSelectInput } from 'components/common/form/select';
import { HitterRosterStatus } from 'lib_ts/enums/hitters.enums';
import { clone } from 'lodash';
import useHittersStore from 'stores/use-hitters-store';

export const SelectHitterRosterStatus = () => {
  const loading = useHittersStore((s) => s.loading);
  const filters = useHittersStore((s) => s.filters);

  return (
    <CommonSelectInput
      id="hitters-roster-status"
      name="status"
      placeholder="common.status"
      options={Object.values(HitterRosterStatus).map((o) => ({
        label: o,
        value: o,
      }))}
      value={filters.status}
      onChange={(v) =>
        useHittersStore.setState((prev) => {
          const nextFilters = clone(prev.filters);

          if (!v) {
            delete nextFilters.status;
          } else {
            nextFilters.status = v as HitterRosterStatus;
          }

          return {
            filters: nextFilters,
          };
        })
      }
      disabled={loading}
      optional
      skipSort
    />
  );
};
